import type { Locale } from '@/intl/types'
import type { GroupBookingData } from '@/scopes/account/group-responsible/domain/types'
import type { GroupBookingAPIResponse } from '@/scopes/account/group-responsible/infrastructure/types'
import { getPeriod } from './utils'

export function mapGroup(data: GroupBookingAPIResponse['data'], locale?: Locale): GroupBookingData['group'] {
  return {
    name: data.groupName ?? '',
    location: '', // TODO: Retrieve from API MS-5143
    period: data.startDate && data.endDate ? getPeriod(data.startDate, data.endDate, locale) : '',
    startingDate: data.startDate ?? '',
    imgSrc: 'https://www.sunweb.nl/-/media/07_sunweb-int/my-accounts/sunweb-my-account-header.ash',
  }
}
